import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { usePlano } from '../hooks/usePlano'
import { grupoService } from '../lib/supabase'
import toast from 'react-hot-toast'

export default function ClassicGruposPage() {
  const { user, profile, signOut } = useAuth()
  const { temClassic } = usePlano()
  const navigate = useNavigate()
  const [grupos, setGrupos] = useState([])
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState(null) // 'criar' | 'entrar'
  const [form, setForm] = useState({ nome: '', descricao: '', codigo: '' })
  const [saving, setSaving] = useState(false)

  const isLicenciado = temClassic

  useEffect(() => { carregarGrupos() }, [user])

  async function carregarGrupos() {
    if (!user) return
    try {
      const data = await grupoService.meuGrupos(user.id, 'classic')
      setGrupos(data)
    } catch {
      toast.error('Erro ao carregar grupos')
    } finally {
      setLoading(false)
    }
  }

  async function criarGrupo() {
    if (!form.nome.trim()) { toast.error('Digite o nome do grupo'); return }
    setSaving(true)
    try {
      const grupo = await grupoService.criarGrupo(
        { nome: form.nome, descricao: form.descricao, tipo: 'orquestra', modulo: 'classic' },
        user.id
      )
      toast.success(`Grupo "${grupo.nome}" criado!`)
      setModal(null)
      setForm({ nome: '', descricao: '', codigo: '' })
      navigate(`/classic/${grupo.id}`)
    } catch (e) {
      toast.error(e.message)
    } finally {
      setSaving(false)
    }
  }

  async function entrarGrupo() {
    if (!form.codigo.trim()) { toast.error('Digite o código de convite'); return }
    setSaving(true)
    try {
      const grupo = await grupoService.entrarPorCodigo(form.codigo.trim())
      if (grupo.modulo !== 'classic') {
        toast.error('Este código é de um grupo CifrasBand, não Classic')
        return
      }
      toast.success(`Entrou no grupo "${grupo.nome}"!`)
      setModal(null)
      navigate(`/classic/${grupo.id}`)
    } catch (e) {
      toast.error(e.message || 'Código inválido')
    } finally {
      setSaving(false)
    }
  }

  const iniciais = (nome) => nome?.split(' ').map(p => p[0]).join('').substring(0, 2).toUpperCase() || '?'
  const coresAv = ['av-red', 'av-gold', 'av-green', 'av-blue']

  return (
    <div className="app-container">
      {/* Header */}
      <div style={{ padding: '20px 20px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button onClick={() => navigate('/grupos')}
            style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 22, cursor: 'pointer', padding: 0 }}>‹</button>
          <div>
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 20, fontWeight: 800, letterSpacing: 0.5 }}>
              <span style={{ color: '#00CFFF' }}>CIFRAS</span><span style={{ color: '#FF8C00' }}>BAND</span>
              <span style={{ color: 'rgba(255,140,0,0.7)', fontSize: 14, fontWeight: 700, marginLeft: 6 }}>CLASSIC</span>
            </div>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 1 }}>
              Partituras e ensaios para orquestra
            </div>
          </div>
        </div>
        <button onClick={() => navigate('/perfil')}
          style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid var(--card-border)', borderRadius: 10, padding: '6px 12px', cursor: 'pointer', fontSize: 18 }}
          title="Meu perfil">
          {profile?.avatar_url
            ? <img src={profile.avatar_url} alt="" style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', verticalAlign: 'middle' }} />
            : '👤'}
        </button>
      </div>

      <div style={{ flex: 1, padding: '24px 20px' }}>

        {/* Badge de licença */}
        {isLicenciado ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', background: 'rgba(255,140,0,0.08)', border: '1px solid rgba(255,140,0,0.25)', borderRadius: 10, marginBottom: 20, fontSize: 13 }}>
            <span>🎖</span>
            <span style={{ color: 'var(--gold)', fontWeight: 600 }}>Licença Classic ativa</span>
            <span style={{ color: 'var(--muted)', fontSize: 11, marginLeft: 'auto' }}>Você pode criar grupos</span>
          </div>
        ) : (
          <div style={{ padding: '14px', background: 'rgba(255,255,255,0.04)', border: '1px solid var(--card-border)', borderRadius: 12, marginBottom: 20 }}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>🎼 Módulo Classic</div>
            <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.5 }}>
              Para <strong>criar grupos</strong> Classic é necessária uma licença.<br />
              Você pode entrar em grupos existentes com um código de convite.
            </div>
          </div>
        )}

        <div className="section-hdr">
          <div className="section-title">Meus Grupos Classic</div>
        </div>

        {/* Botões de ação */}
        <div style={{ display: 'grid', gridTemplateColumns: isLicenciado ? '1fr 1fr' : '1fr', gap: 10, marginBottom: 24 }}>
          {isLicenciado && (
            <button className="btn btn-primary" onClick={() => setModal('criar')}>
              + Criar grupo
            </button>
          )}
          <button className="btn" onClick={() => setModal('entrar')}>
            🔑 Entrar com código
          </button>
        </div>

        {/* Lista de grupos */}
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
            <div className="spinner" />
          </div>
        ) : grupos.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🎼</div>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Nenhum grupo Classic ainda</div>
            <div style={{ fontSize: 14, color: 'var(--muted)' }}>
              {isLicenciado
                ? 'Crie um grupo ou entre com um código de convite'
                : 'Entre em um grupo com um código de convite'}
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {grupos.map((g, i) => (
              <div key={g.id} className="card" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 14 }}
                onClick={() => navigate(`/classic/${g.id}`)}>
                <div className={`avatar av-md ${coresAv[i % 4]}`} style={{ fontSize: 18 }}>
                  {iniciais(g.nome)}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>{g.nome}</div>
                  <div style={{ fontSize: 12, color: 'var(--muted)' }}>
                    {g.descricao || 'Grupo Classic'} • {g.meu_papel === 'admin' ? '👑 Maestro' : 'Músico'}
                  </div>
                </div>
                <div style={{ fontSize: 12, color: 'var(--gold)', fontFamily: 'Montserrat, monospace', background: 'rgba(255,140,0,0.08)', border: '1px solid rgba(255,140,0,0.2)', padding: '4px 10px', borderRadius: 8, fontWeight: 700, letterSpacing: 1 }}>
                  {(() => { const c = (g.codigo_convite || '').toUpperCase(); return c.length === 8 ? `${c.slice(0,4)}-${c.slice(4)}` : c.length === 6 ? `${c.slice(0,3)}-${c.slice(3)}` : c })()}
                </div>
                <div style={{ color: 'var(--muted)' }}>›</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modal Criar */}
      {modal === 'criar' && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div className="modal-handle" onClick={() => setModal(null)} />
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 20, fontWeight: 700, marginBottom: 6 }}>
              Criar grupo Classic
            </div>
            <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 20 }}>
              Um código de convite será gerado automaticamente
            </div>
            <div className="input-group">
              <label className="input-label">Nome do grupo / orquestra</label>
              <input className="input" placeholder="Ex: Orquestra Municipal, Banda Sinfônica..." value={form.nome}
                onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} autoFocus />
            </div>
            <div className="input-group" style={{ marginBottom: 20 }}>
              <label className="input-label">Descrição (opcional)</label>
              <input className="input" placeholder="Ex: Orquestra de câmara da cidade" value={form.descricao}
                onChange={e => setForm(f => ({ ...f, descricao: e.target.value }))} />
            </div>
            <button className="btn btn-primary btn-block" onClick={criarGrupo} disabled={saving}
              style={{ height: 52, fontSize: 15, fontWeight: 700 }}>
              {saving ? <span className="spinner" /> : '🎼 Criar grupo Classic'}
            </button>
          </div>
        </div>
      )}

      {/* Modal Entrar */}
      {modal === 'entrar' && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div className="modal-handle" onClick={() => setModal(null)} />
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 20, fontWeight: 700, marginBottom: 6 }}>
              Entrar em um grupo Classic
            </div>
            <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 20 }}>
              Peça o código de convite para o maestro do grupo
            </div>
            <div className="input-group" style={{ marginBottom: 20 }}>
              <label className="input-label">Código de convite</label>
              <input className="input" placeholder="Ex: a3f7b2c1" value={form.codigo}
                onChange={e => setForm(f => ({ ...f, codigo: e.target.value }))}
                autoFocus style={{ textTransform: 'lowercase', letterSpacing: 2, fontFamily: 'monospace' }} />
            </div>
            <button className="btn btn-primary btn-block" onClick={entrarGrupo} disabled={saving}
              style={{ height: 52, fontSize: 15, fontWeight: 700 }}>
              {saving ? <span className="spinner" /> : '🔑 Entrar no grupo'}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
